import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  checkTicketDaschoardStatus,
  fetchSettings,
  fetchWizardStep,
} from "TicketAction";
import { fetchEventDetails } from "DashboardUserAction";
import { fetchFormBuilder } from "FormBuilderAction";
import LocaleStrings from "Languages";

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  componentDidMount() {
    // this.props.checkTicketDaschoardStatus(this.props.session);
    // this.props.fetchEventDetails(this.props.session);
    // this.props.fetchSettings(this.props.session);
    // this.props.fetchFormBuilder(this.props.session)
  }

  redirectUrl = (e) => {
    e.preventDefault();
    let clicked_step = e.currentTarget.dataset.data_id;
    let current_step = this.props.WizardStep;
    let clicked_stepArr = clicked_step.split("_");
    let current_stepArr = current_step.split("_");

    let settingData = this.props.settingData;

    let companyname =
      settingData && settingData.length > 0 && settingData[0].companyname
        ? settingData[0].companyname
        : "";
    let companyaddress =
      settingData && settingData.length > 0 && settingData[0].companyaddress
        ? settingData[0].companyaddress
        : "";
    let supportemail =
      settingData && settingData.length > 0 && settingData[0].supportemail
        ? settingData[0].supportemail
        : "";

    if (clicked_stepArr[1] < current_stepArr[1]) {
      this.props.fetchWizardStep(clicked_step);
    } else if (
      clicked_stepArr[1] > current_stepArr[1] &&
      companyname &&
      companyaddress &&
      supportemail
    ) {
      this.props.fetchWizardStep(clicked_step);
    }
  };

  render() {
    let { ticketDashboard, eventDetails, settingData, WizardStep } = this.props;
    let ticketList =
      this.props.ticketList && this.props.ticketList.resource
        ? this.props.ticketList.resource
        : [];
    let formBuildeList =
      this.props.formBuildeList && this.props.formBuildeList.resource
        ? this.props.formBuildeList.resource
        : [];

    let orgIcon = "fa fa-exclamation-circle";
    let orgStyle = "steps-not-filled";

    let companyname =
      settingData && settingData.length > 0 && settingData[0].companyname
        ? settingData[0].companyname
        : "";
    let companyaddress =
      settingData && settingData.length > 0 && settingData[0].companyaddress
        ? settingData[0].companyaddress
        : "";
    let supportemail =
      settingData && settingData.length > 0 && settingData[0].supportemail
        ? settingData[0].supportemail
        : "";

    if (companyname && companyaddress && supportemail) {
      orgIcon = "fa fa-check-circle";
      orgStyle = "steps-filled";
    }

    let activeStep1 = WizardStep == "step_1" ? "activestepColor" : "stepColor";
    let activeStep2 = WizardStep == "step_2" ? "activestepColor" : "stepColor";
    let activeStep3 = WizardStep == "step_3" ? "activestepColor" : "stepColor";
    let activeStep4 = WizardStep == "step_4" ? "activestepColor" : "stepColor";
    let activeStep5 = WizardStep == "step_5" ? "activestepColor" : "stepColor";

    let ticketIcon = "fa fa-exclamation-circle";
    let ticketStyle = "steps-not-filled";

    if (ticketList && ticketList.length > 0) {
      ticketIcon = "fa fa-check-circle";
      ticketStyle = "steps-filled";
    }

    let checkoutIcon = "fa fa-exclamation-circle";
    let checkoutStyle = "steps-not-filled";

    if (formBuildeList && formBuildeList.length > 0) {
      checkoutIcon = "fa fa-check-circle";
      checkoutStyle = "steps-filled";
    }

    let sessionIcon = "fa fa-exclamation-circle";
    let sessionStyle = "steps-not-filled";

    let publishIcon = "fa fa-exclamation-circle";
    let publisStyle = "steps-not-filled";

    if (
      ticketDashboard &&
      ticketDashboard.ticket &&
      !ticketDashboard.paidticket &&
      ticketDashboard.setting
    ) {
      publishIcon = "fa fa-check-circle";
      publisStyle = "steps-filled";
    } else if (
      ticketDashboard &&
      ticketDashboard.ticket &&
      ticketDashboard.paidticket &&
      ticketDashboard.paymentgateway &&
      ticketDashboard.setting
    ) {
      publishIcon = "fa fa-check-circle";
      publisStyle = "steps-filled";
    }

    return (
      <div>
        <ul className="wizard_breadcrumb breadcrumb-ipad">
          <li>
            <a href="#" data-data_id="step_1" onClick={this.redirectUrl}>
              <div style={{ display: "flex" }}>
                <div>
                  <i
                    className={`${orgIcon} ${orgStyle}`}
                    aria-hidden="true"
                  ></i>{" "}
                </div>
                {/* <div>
                  {" "}
                  <img
                    src="../../style/images/header-icons/checkmark-circle-fill.png"
                    style={{ paddingRight: 4 }}
                  ></img>{" "}
                </div> */}
                <div className={activeStep1}>
                  {LocaleStrings.user_reg_wizard_tab_1}
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="#" data-data_id="step_2" onClick={this.redirectUrl}>
              <div style={{ display: "flex" }}>
                <div>
                  <i
                    className={`${ticketIcon} ${ticketStyle}`}
                    aria-hidden="true"
                  ></i>{" "}
                </div>
                {/* <div>
                  {" "}
                  <img
                    src="../../style/images/header-icons/checkmark-circle-fill.png"
                    style={{ paddingRight: 4 }}
                  ></img>{" "}
                </div> */}
                <div className={activeStep2}>
                  {LocaleStrings.user_reg_wizard_tab_2}
                </div>
              </div>
            </a>
          </li>

          <li>
            <a href="#" data-data_id="step_3" onClick={this.redirectUrl}>
              <div style={{ display: "flex" }}>
                <div>
                  <i
                    className={`${checkoutIcon} ${checkoutStyle}`}
                    aria-hidden="true"
                  ></i>{" "}
                </div>
                {/* <div>
                  {" "}
                  <img
                    src="../../style/images/header-icons/checkmark-circle-fill.png"
                    style={{ paddingRight: 4 }}
                  ></img>{" "}
                </div> */}
                <div className={activeStep3}>
                  {LocaleStrings.user_reg_wizard_tab_3}
                </div>
              </div>
            </a>
          </li>

          <li>
            <a href="#" data-data_id="step_4" onClick={this.redirectUrl}>
              <div style={{ display: "flex" }}>
                {/* <div>
                  <i
                    className={`${sessionIcon} ${sessionStyle}`}
                    aria-hidden="true"
                  ></i>{" "}
                </div> */}
                <div className={activeStep4}>
                  {LocaleStrings.user_reg_wizard_tab_4}
                </div>
              </div>
            </a>
          </li>

          <li>
            <a href="#" data-data_id="step_5" onClick={this.redirectUrl}>
              <div style={{ display: "flex" }}>
                <div>
                  <i
                    className={`${publishIcon} ${publisStyle}`}
                    aria-hidden="true"
                  ></i>{" "}
                </div>
                {/* <div>
                  {" "}
                  <img
                    src="../../style/images/header-icons/checkmark-circle-fill.png"
                    style={{ paddingRight: 4 }}
                  ></img>{" "}
                </div> */}
                <div className={activeStep5}>
                  {LocaleStrings.user_reg_wizard_tab_5}
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    ticketDashboard: state.ticketDashboard.data,
    eventDetails: state.userEventDetails,
    settingData: state.SettingData.resource,
    WizardStep: state.WizardStep,
    ticketList: state.TicketList,
    formBuildeList: state.formBuildeList,
  };
}
export default connect(mapStateToProps, {
  checkTicketDaschoardStatus,
  fetchSettings,
  fetchEventDetails,
  fetchWizardStep,
  fetchFormBuilder,
})(Navigation);
